/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const ENTRY_POINTS = {
  HP: {
    base: 'house-plans',
    prefix: 'hp',
  },
  QQ: {
    base: 'house-plans',
    prefix: 'hp',
  },
  JE: {
    base: 'jobs',
    prefix: 'job',
  },
};

export function getGTOEndpoint(pattern: string, entryPoint: string): string {
  const entryDetails = ENTRY_POINTS[entryPoint];
  const path = pattern.replace(/#/, entryDetails.prefix);
  return `/${entryDetails.base}/${path}`;
}
